module.exports = __webpack_public_path__ + "static/proprioceptive_c-25163a0a8678fdcfe45255c21213e6d0.png";